import * as React from "react"
import 'intersection-observer';
import { Action, IOWidget, mk_widget } from "widgets-for-react"
import { CMSState } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { Gutenberg } from "../../../../wordpress/types_and_parser/types.ext.gen";
import { link, linkWrapper, simpleLink } from "../../../../cms/blocks/utils.gen";
import ReactPlayer from 'react-player'
import { getCookieStatus } from "../../../../cms/blocks/cookiebar.utils.mod";
import { CookieSensitiveContentWrapper } from "../../../../cms/blocks/cookiebar.mod";



export type ThemesOverviewBlockProps<extra_images> = {
  // Block state 
  index: number,
  overlayOpen: boolean

  // Block props
  title: string,

  sidebar_title: string,
  side_bar_link_text: string,
  side_bar_link_url: string,

  sidebar_item1_amount: string,
  sidebar_item1_title: string,
  sidebar_item1_intro: string,
  sidebar_item1_image_url: string,
  sidebar_item1_image_id: number,

  sidebar_item2_amount: string,
  sidebar_item2_title: string,
  sidebar_item2_intro: string,
  sidebar_item2_image_url: string,
  sidebar_item2_image_id: number,

  sidebar_item3_amount: string,
  sidebar_item3_title: string,
  sidebar_item3_intro: string,
  sidebar_item3_image_url: string,
  sidebar_item3_image_id: number,

  sidebar_item4_amount: string
  sidebar_item4_title: string
  sidebar_item4_intro: string
  sidebar_item4_image_url: string
  sidebar_item4_image_id: number

  blocks: Array<Gutenberg.Vidda.ThemesOverviewItem>
}

export type ThemesOverviewBlockStyle = Partial<{
  block_contentwidth_classname: string
  block_fullwidth_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  visual_classname: string
  image_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function ThemsesOverviewBlock<customBlockData, extra_images>(
  props: ThemesOverviewBlockProps<extra_images>,
  options?: { style?: ThemesOverviewBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: (setState) => {

        const setBlockState = <K extends keyof ThemesOverviewBlockProps<extra_images>>(prop: K, newValue: ThemesOverviewBlockProps<extra_images>[K]) => (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>): CMSState<customBlockData, extra_images, PublicSite_CustomPageData> => {
          if (!s.blocks.has(props.index)) return s
          let current_block = s.blocks.get(props.index) as any
          if (current_block.kind != 'themesOverviewBlock') return s
          current_block = ({
            ...current_block,
            value: {
              ...current_block.value,
              fst: {
                ...current_block.value.fst,
                [prop]: newValue
              },

            }
          })
          return ({ ...s, blocks: s.blocks.set(props.index, current_block) })
        }

        // Utility functions for overlay, use this to set the overlay state or to stop the video from playing when closed
        const toggleOverlay = (): void => {
          setState(setBlockState('overlayOpen', !props.overlayOpen)),
            document.documentElement.classList.add('overflow--hidden')
        }
        const closeOverlay = (): void => {
          setState(setBlockState('overlayOpen', false)),
            document.documentElement.classList.remove('overflow--hidden')
        }
        const openOverlay = (): void => {
          setState(setBlockState('overlayOpen', false))
        }

        return (
          <>
            <div className="block block--overview">
              <div className="block__inner block__inner--main container--xl grid--block">
                <header className="block__header block__header--main">
                  {props.title && <h2 className="block__title typo--3xl">{props.title}</h2>}
                </header>
                <section className="block block--nested-grid block--ng block--ng-primary">
                  <div className="block__inner">
                    <div className="block__content">
                      <ul className="cards">
                        {props.blocks.slice(0, 3).map((b, i) => {
                          const Article = () => <article className="card__inner">
                            <header className="card__header">
                              {b.attrs.title && <h3 className="card__title typo--l fw--light">
                                {b.attrs.title}
                              </h3>}
                              {b.attrs.label && <p className="card__label typo--3xs">{b.attrs.label}</p>}
                              {b.attrs.link_text && <>
                                <span className="button button--primary">
                                  <span>{b.attrs.link_text}</span>
                                </span>
                                <div className="card__fauxlink">
                                  <span className="typo--2xs">{b.attrs.link_text}</span>
                                  <svg className="card__icon" height="10" width="6" aria-hidden="true">
                                    <use xlinkHref="#chevron--right" />
                                  </svg>
                                </div>
                              </>
                              }
                            </header>
                            {b.attrs.image_id && b.attrs.image_url && (<div className={`card__visual fit-object has-${b.attrs.isVideo ? 'video' : 'image'}`}>
                              <img
                                className="card__image"
                                width="440px"
                                height="220px"
                                alt=""
                                src={b.attrs.image_url}
                              />
                            </div>
                            )}
                          </article>

                          const isFirstVideo = i == 0 && b.attrs.isVideo
                          // When it is the first render only the article item without a link arround out, the onclick will open the video in an overlay
                          return (
                            <li className="card card--first-grid card--fg" onClick={isFirstVideo ? toggleOverlay : null}>
                              {isFirstVideo ?
                                <button className="card__link">
                                  <Article />
                                </button>
                                :
                                link(linkWrapper({ title: b.attrs.title, url: b.attrs.link_url }), { classname: 'card__link' }, <Article />)
                              }
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                </section>
                <section className="block block--sidebar">
                  {props.side_bar_link_url && props.side_bar_link_text &&
                    (simpleLink(linkWrapper(
                      {
                        title: props.side_bar_link_text,
                        url: props.side_bar_link_url
                      }),
                      { classname: "block__link--sidebar" },
                      <>
                        <div className="block__inner">
                          <header className="block__header">
                            {props.sidebar_title && <h2 className="block__title t--l ff--preciuos fw--light">{props.sidebar_title}</h2>}
                          </header>
                          <div className="block__content">
                            <ul className="block__cards cards">
                              {(props.sidebar_item1_title || props.sidebar_item1_amount || props.sidebar_item1_intro || props.sidebar_item1_image_id) && (
                                <li className="card card--grid">
                                  <article className="card__inner">
                                    <header className="card__header">
                                      {props.sidebar_item1_title && (
                                        <h3 className="card__title t--2xs ff--doyle fw--light">{props.sidebar_item1_title}</h3>
                                      )}
                                      {props.sidebar_item1_amount && (
                                        <p className="card__amount typo--3xl">{props.sidebar_item1_amount}</p>
                                      )}
                                      {props.sidebar_item1_intro && (
                                        <p className="card__intro t--3xs ff--preciuos">{props.sidebar_item1_intro}</p>
                                      )}
                                    </header>
                                    {props.sidebar_item1_image_id && props.sidebar_item1_image_url && (<div className="card__visual">
                                      <img width="70px" alt="" src={props.sidebar_item1_image_url} />
                                    </div>
                                    )}
                                  </article>
                                </li>
                              )}
                              {(props.sidebar_item2_title || props.sidebar_item2_amount || props.sidebar_item2_intro || props.sidebar_item2_image_id) && (
                                <li className="card card--grid">
                                  <article className="card__inner">
                                    <header className="card__header">
                                      {props.sidebar_item2_title && (
                                        <h3 className="card__title t--2xs ff--doyle fw--light">{props.sidebar_item2_title}</h3>
                                      )}
                                      {props.sidebar_item2_amount && (
                                        <p className="card__amount typo--3xl">{props.sidebar_item2_amount}</p>
                                      )}
                                      {props.sidebar_item2_intro && (
                                        <p className="card__intro t--3xs ff--preciuos">{props.sidebar_item2_intro}</p>
                                      )}
                                    </header>
                                    {props.sidebar_item2_image_id && props.sidebar_item2_image_url && (<div className="card__visual">

                                      <img width="70px" alt="" src={props.sidebar_item2_image_url} />
                                    </div>
                                    )}
                                  </article>
                                </li>
                              )}
                              {(props.sidebar_item3_title || props.sidebar_item3_amount || props.sidebar_item3_intro || props.sidebar_item3_image_id) && (
                                <li className="card card--grid">
                                  <article className="card__inner">
                                    <header className="card__header">
                                      {props.sidebar_item3_title && (
                                        <h3 className="card__title t--2xs ff--doyle fw--light">{props.sidebar_item3_title}</h3>
                                      )}
                                      {props.sidebar_item3_amount && (
                                        <p className="card__amount typo--3xl">{props.sidebar_item3_amount}</p>
                                      )}
                                      {props.sidebar_item3_intro && (
                                        <p className="card__intro t--3xs ff--preciuos">{props.sidebar_item3_intro}</p>
                                      )}
                                    </header>
                                    {props.sidebar_item3_image_id && props.sidebar_item3_image_url && (<div className="card__visual">

                                      <img width="70px" alt="" src={props.sidebar_item3_image_url} />
                                    </div>
                                    )}
                                  </article>
                                </li>
                              )}
                              {(props.sidebar_item4_title || props.sidebar_item4_amount || props.sidebar_item4_intro || props.sidebar_item4_image_id) && (
                                <li className="card card--grid">
                                  <article className="card__inner">
                                    <header className="card__header">
                                      {props.sidebar_item4_title && (
                                        <h3 className="card__title t--2xs ff--doyle fw--light">{props.sidebar_item4_title}</h3>
                                      )}
                                      {props.sidebar_item4_amount && (
                                        <p className="card__amount typo--3xl">{props.sidebar_item4_amount}</p>
                                      )}
                                      {props.sidebar_item4_intro && (
                                        <p className="card__intro t--3xs ff--preciuos">{props.sidebar_item4_intro}</p>
                                      )}
                                    </header>
                                    {props.sidebar_item4_image_id && props.sidebar_item4_image_url && (<div className="card__visual">

                                      <img width="70px" alt="" src={props.sidebar_item4_image_url} />
                                    </div>
                                    )}
                                  </article>
                                </li>
                              )}
                            </ul>
                          </div>
                          <footer className="block__footer">
                            <span className="blob-button bb--secondary">
                              <span className="blob-button__label typo--2xs">{props.side_bar_link_text}</span>
                              <div className="blob-button__icon" aria-hidden="true" />
                            </span>
                          </footer>
                        </div>
                      </>))}
                </section>
                <section className="block block--nested-grid block--ng block--ng-secondary">
                  <div className="block__inner">
                    <div className="block__content">
                      <ul className="cards">
                        {props.blocks.slice(3, props.blocks.length).map((b) => (
                          <li className="card card--second-grid card--sg">
                            {link(linkWrapper(
                              {
                                title: b.attrs.title,
                                url: b.attrs.link_url
                              }),
                              { classname: "card__link" },
                              <article className="card__inner">
                                <header className="card__header">
                                  {b.attrs.title && <h3 className="card__title typo--l fw--light">
                                    {b.attrs.title}
                                    {b.attrs.link_text && <div className="blob-button bb--primary">
                                      <span className="blob-button__label typo--2xs">{b.attrs.link_text}</span>
                                      <div className="blob-button__icon" aria-hidden="true" />
                                    </div>}
                                  </h3>}
                                  {b.attrs.label && <p className="card__label typo--3xs">{b.attrs.label}</p>}
                                  {b.attrs.link_text && <>
                                    <span className="button button--primary">
                                      <span>{b.attrs.link_text}</span>
                                    </span>
                                    <div className="card__fauxlink">
                                      <span className="typo--2xs">{b.attrs.link_text}</span>
                                      <svg className="card__icon" height="10" width="6" aria-hidden="true">
                                        <use xlinkHref="#chevron--right" />
                                      </svg>
                                    </div>
                                  </>
                                  }
                                </header>
                                <div className={`card__visual has-${b.attrs.isVideo ? 'video' : 'image'}`}>
                                  {b.attrs.image_id && (
                                    <img
                                      className="card__image"
                                      width="440px"
                                      height="220px"
                                      alt=""
                                      src={b.attrs.image_url}
                                    />
                                  )}
                                </div>
                              </article>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            {props.overlayOpen && props.blocks.length > 0 && props.blocks[0].attrs.isVideo && <div className="popup__overlay">
              <div className="popup">
                  <CookieSensitiveContentWrapper
                    groupId={4}
                    options={{
                      style: {
                        cookies_classname: 'popup__cookies',
                        cookies_inner_classname: 'popup__cookies-inner',
                        cookies_text_classname: 'popup__text',
                        cookies_clickable_classname: ''
                      }
                    }}
                    placeholder={
                      <div className="media__placeholder text--styled">
                        <div className="media__inner">
                          <p>If you wish to view this video, you need to accept 'Targeting Cookies' as they are required for this functionality.</p>
                          <p>Please <a className="optanon-toggle-display" onClick={() => window.Optanon.ToggleInfoDisplay()}>adjust your cookie preferences here</a>.</p>
                        </div>
                      </div>
                    }
                  >
                  <figure className="popup__visual">
                    <ReactPlayer url={props.blocks[0].attrs.link_url}
                      playing={props.overlayOpen}
                      controls
                      muted
                    />
                  </figure>
                </CookieSensitiveContentWrapper>
              </div>
              <button onClick={closeOverlay} className="popup__close">
                <svg width="48" height="47" viewBox="0 0 48 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.8" d="M1.14397 30.674C-0.112848 25.5953 -0.336711 20.3192 0.485458 15.1537C0.818639 13.059 1.82318 11.3414 2.41178 9.9895C2.8993 8.84749 3.5597 7.78592 4.3702 6.84145C6.5612 4.31735 11.1344 0.567277 19.2292 0.0635891C29.209 -0.560362 35.4709 3.59153 36.6838 4.4744C36.8408 4.58829 36.9999 4.69794 37.1625 4.80547C39.0439 6.04842 50.3221 14.1704 47.5696 28.58C44.8635 42.7434 31.0404 45.7478 28.3528 46.2013C28.0675 46.2494 27.7821 46.306 27.5003 46.3746C25.0189 46.9795 11.5418 49.5672 3.39277 36.8463C3.39277 36.8463 2.18704 34.8867 1.14397 30.674Z" fill="white" />
                </svg>
              </button>
            </div>}
          </>
        )
      },
    });
}
